import { FueledAccessibleScript } from './FueledAccessibleScript';
import { FueledBingScript } from './FueledBingScript';
import { FueledClientScript } from './FueledClientScript';
import { FueledGtmScript } from './FueledGtmScript';
import { FueledImpactScript } from './FueledImpactScript';
import { FueledKlaviyoScript } from './FueledKlaviyoScript';
import { FueledMntnScript } from './FueledMntnScript';
//import { FueledPinterestScript } from './FueledPinterestScript';
import { FueledTikTokScript } from './FueledTikTokScript';
import { FueledCuVimeoTracking } from './FueledCuVimeoTracking';
import {
  FueledOneTrustScript,
  useGetOneTrustConsent,
} from './FueledOneTrustScript';
import { FueledShopMyScript } from './FueledShopMyScript';
import { FueledAmazonScript } from './FueledAmazonScript';
import { useAnalytics } from './hooks';
import { FueledDataLayer } from './FueledDataLayer';

const gtmContainerId = 'GTM-WPGVRLTQ';
const bingId = '5797150';
const impactPixelId = 'A1806740-b579-4dc0-ad40-78a08792fad51';
const klaviyoId = 'H6yLPD';
const mntnPixelId = '34984';
const openTrustId = '01936375-4867-7f55-a10f-2e17bf6f641a';
//const pinterestPixelId = '2612642693140';
const tiktokPixelId = 'C594AM16C8J46GAV3TH0';
const shopMyScriptId = 'sms_aff_clicktrack_briogeo';
const amazonTagId = '95b48d78-c0e2-4811-aa07-5e0ea88ebceb';

const scripts = [
  { Component: FueledAccessibleScript, consent: ['all'] },
  { withKey: openTrustId, Component: FueledOneTrustScript, consent: ['all'] },
  { Component: FueledClientScript, consent: ['all'] },
  { Component: FueledDataLayer, consent: ['all'] },
  { withKey: bingId, Component: FueledBingScript, consent: ['marketing'] },
  {
    withKey: impactPixelId,
    Component: FueledImpactScript,
    consent: ['marketing'],
  },
  {
    withKey: klaviyoId,
    Component: FueledKlaviyoScript,
    consent: ['marketing'],
  },
  { withKey: mntnPixelId, Component: FueledMntnScript, consent: ['marketing'] },
  { withKey: gtmContainerId, Component: FueledGtmScript, consent: ['all'] },
  //{ withKey: pinterestPixelId, Component: FueledPinterestScript },
  {
    withKey: tiktokPixelId,
    Component: FueledTikTokScript,
    consent: ['marketing'],
  },
  { Component: FueledCuVimeoTracking, consent: ['analytics'] },
  {
    withKey: shopMyScriptId,
    Component: FueledShopMyScript,
    // consent: ['marketing'],
    consent: ['all'],
  },
  {
    withKey: amazonTagId,
    Component: FueledAmazonScript,
    consent: ['marketing'],
  },
];

export const Fueled = () => {
  const consent = useGetOneTrustConsent();
  useAnalytics(consent); // init analytics

  if (!consent) {
    return (
      <>
        <FueledDataLayer />
        <FueledOneTrustScript withKey={openTrustId} />
      </>
    );
  }

  return (
    <>
      {/* Uncomment the following line to enable the FueledDlDebug component */}
      {/* <FueledDlDebug /> */}
      {scripts
        .filter(
          ({ consent: componentConsent }) =>
            componentConsent.includes('all') ||
            componentConsent.every((c) => consent[c])
        )
        .map(({ withKey, Component, key }, index) => (
          <Component withKey={withKey ? withKey : ''} key={key ? key : index} />
        ))}
    </>
  );
};
